import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.includes";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.splice";
import "core-js/modules/es.function.name";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.includes";
import "core-js/modules/web.dom-collections.for-each";
import "core-js/modules/web.dom-collections.iterator";
import _typeof from "/Users/guoshengli/Documents/vue/kexin-qiye/node_modules/@babel/runtime/helpers/esm/typeof";
import _objectSpread from "/Users/guoshengli/Documents/vue/kexin-qiye/node_modules/@babel/runtime/helpers/esm/objectSpread2";
export default {
  //  自定义标题组件(特殊)
  'block': function block(h, value, vm, _ref) {
    var width = _ref.width,
        _ref$attrs = _ref.attrs,
        attrs = _ref$attrs === void 0 ? {} : _ref$attrs,
        defaultValue = _ref.defaultValue,
        _ref$props = _ref.props,
        props = _ref$props === void 0 ? {} : _ref$props,
        _ref$style = _ref.style,
        style = _ref$style === void 0 ? {} : _ref$style,
        _ref$render = _ref.render,
        render = _ref$render === void 0 ? {
      before: null,
      append: null,
      after: null
    } : _ref$render;
    if (!style.width) style.width = width || vm.componentWidth;
    value = value || defaultValue;
    return [typeof render.before === 'function' ? render.before.call(vm, h) : [], value ? h('div', {
      style: _objectSpread({
        display: 'flex',
        alignItems: 'center',
        marginRight: style.width
      }, style),
      attrs: _objectSpread({}, attrs),
      props: _objectSpread({
        value: value
      }, props)
    }, [h('span', {
      style: {
        borderLeft: '2px solid #409eff',
        width: '3px',
        height: '22px',
        lineHeight: '22px'
      }
    }), h('span', {
      style: {
        paddingLeft: '5px',
        color: '#777777',
        fontSize: '20px'
      }
    }, value)]) : '', typeof render.after === 'function' ? render.after.call(vm, h) : []];
  },
  //  自定义文本组件(特殊)
  'text': function text(h, value, vm, _ref2) {
    var _ref2$loading = _ref2.loading,
        loading = _ref2$loading === void 0 ? false : _ref2$loading,
        _ref2$on = _ref2.on,
        on = _ref2$on === void 0 ? {} : _ref2$on,
        _ref2$width = _ref2.width,
        width = _ref2$width === void 0 ? '' : _ref2$width,
        _ref2$inline = _ref2.inline,
        inline = _ref2$inline === void 0 ? true : _ref2$inline,
        _ref2$attrs = _ref2.attrs,
        attrs = _ref2$attrs === void 0 ? {} : _ref2$attrs,
        _ref2$props = _ref2.props,
        props = _ref2$props === void 0 ? {} : _ref2$props,
        _ref2$style = _ref2.style,
        style = _ref2$style === void 0 ? {} : _ref2$style,
        _ref2$render = _ref2.render,
        render = _ref2$render === void 0 ? {
      before: null,
      append: null,
      after: null
    } : _ref2$render;
    if (!style.width) style.width = width || vm.componentWidth;
    var textSpan = h('span', {
      style: _objectSpread({
        display: inline ? 'block' : 'inline',
        fontSize: '15px',
        color: '#777777',
        lineHeight: '32px',
        height: '32px',
        overflow: 'hidden',
        'text-overflow': 'ellipsis',
        'white-space': 'nowrap'
      }, style),
      attrs: _objectSpread({}, attrs),
      props: _objectSpread({
        value: value
      }, props),
      directives: [{
        name: 'loading',
        value: loading
      }],
      on: _objectSpread({}, on)
    }, value);

    if (!attrs.tooltip) {
      return [typeof render.before === 'function' ? render.before.call(vm, h) : [], textSpan, typeof render.after === 'function' ? render.after.call(vm, h) : []];
    } else {
      return [typeof render.before === 'function' ? render.before.call(vm, h) : [], h('el-tooltip', {
        attrs: {
          effect: 'dark',
          content: value,
          placement: 'top',
          'popper-class': 'p-form-schema-tooltip'
        }
      }, [textSpan]), typeof render.after === 'function' ? render.after.call(vm, h) : []];
    }
  },
  //  复选列表组件(特殊)
  'el-checkbox': function elCheckbox(h, value, vm, _ref3) {
    var _ref3$loading = _ref3.loading,
        loading = _ref3$loading === void 0 ? false : _ref3$loading,
        inline = _ref3.inline,
        width = _ref3.width,
        _ref3$items = _ref3.items,
        items = _ref3$items === void 0 ? [] : _ref3$items,
        _ref3$all = _ref3.all,
        all = _ref3$all === void 0 ? '' : _ref3$all,
        name = _ref3.name,
        _ref3$on = _ref3.on,
        on = _ref3$on === void 0 ? {} : _ref3$on,
        _ref3$attrs = _ref3.attrs,
        attrs = _ref3$attrs === void 0 ? {} : _ref3$attrs,
        _ref3$props = _ref3.props,
        props = _ref3$props === void 0 ? {} : _ref3$props,
        _ref3$style = _ref3.style,
        style = _ref3$style === void 0 ? {} : _ref3$style,
        _ref3$checkAllDisable = _ref3.checkAllDisabled,
        checkAllDisabled = _ref3$checkAllDisable === void 0 ? false : _ref3$checkAllDisable,
        _ref3$keys = _ref3.keys,
        keys = _ref3$keys === void 0 ? null : _ref3$keys,
        _ref3$render = _ref3.render,
        render = _ref3$render === void 0 ? {
      before: null,
      after: null
    } : _ref3$render,
        _ref3$ref = _ref3.ref,
        ref = _ref3$ref === void 0 ? null : _ref3$ref;
    if (!style.width) style.width = inline ? width || vm.componentWidth : '';

    if (value.length > 0) {
      if (value.includes(all) || all && all !== undefined && value.length === items.length - 1) {
        var ids = items.map(function (m) {
          return keys ? m[keys['value']] : m['value'];
        });
        vm.checkAll = ids;
        value = JSON.parse(JSON.stringify(ids));
      }
    }

    return [typeof render.before === 'function' ? render.before.call(vm, h) : [], h('el-checkbox-group', {
      style: _objectSpread({}, style),
      attrs: _objectSpread({}, attrs),
      props: _objectSpread({
        value: value
      }, props),
      directives: [{
        name: 'loading',
        value: loading
      }],
      on: _objectSpread(_objectSpread({}, on), {}, {
        input: function input(val) {
          // 包含全部选中的逻辑
          if ((all + '').length > 0) {
            var option = [];
            items.filter(function (m) {
              var allValue = keys ? m[keys['value']] : m['value'];

              if (allValue === all) {
                option.push(m);
              }
            });

            if (option.length > 0) {
              if (val.includes(all) && !vm.checkAll.includes(all) || !val.includes(all) && !vm.checkAll.includes(all) && items.length - 1 === val.length) {
                val = [];
                items.forEach(function (item, index) {
                  if (checkAllDisabled) {
                    item.disabled = index !== 0;
                  }

                  val.push(keys ? item[keys['value']] : item['value']);
                });
              } else if (!val.includes(all) && vm.checkAll.includes(all)) {
                val = [];
                items.forEach(function (item) {
                  item.disabled = false;
                });
              } else if (val.includes(all)) {
                val.splice(val.indexOf(all), 1);
              }

              vm.checkAll = val;
            }
          }

          vm.formValues[name] = val;
        }
      }),
      ref: ref || ref
    }, (items || []).map(function (option, index) {
      return h('el-checkbox', {
        props: {
          key: option.value,
          disabled: option.disabled,
          label: keys ? option[keys['value']] : option['value']
        }
      }, [keys ? option[keys['label']] : option['label']]);
    })), typeof render.after === 'function' ? render.after.call(vm, h) : []];
  },
  //  单选列表组件(特殊)
  'el-radio': function elRadio(h, value, vm, _ref4) {
    var _ref4$loading = _ref4.loading,
        loading = _ref4$loading === void 0 ? false : _ref4$loading,
        inline = _ref4.inline,
        _ref4$items = _ref4.items,
        items = _ref4$items === void 0 ? [] : _ref4$items,
        width = _ref4.width,
        _ref4$on = _ref4.on,
        on = _ref4$on === void 0 ? {} : _ref4$on,
        _ref4$attrs = _ref4.attrs,
        attrs = _ref4$attrs === void 0 ? {} : _ref4$attrs,
        _ref4$props = _ref4.props,
        props = _ref4$props === void 0 ? {} : _ref4$props,
        _ref4$style = _ref4.style,
        style = _ref4$style === void 0 ? {} : _ref4$style,
        _ref4$render = _ref4.render,
        render = _ref4$render === void 0 ? {
      before: null,
      after: null
    } : _ref4$render,
        _ref4$keys = _ref4.keys,
        keys = _ref4$keys === void 0 ? null : _ref4$keys;
    if (!style.width) style.width = inline ? width || vm.componentWidth : '';
    return [typeof render.before === 'function' ? render.before.call(vm, h) : [], h('el-radio-group', {
      style: _objectSpread({}, style),
      attrs: _objectSpread({}, attrs),
      props: _objectSpread({
        value: value
      }, props),
      directives: [{
        name: 'loading',
        value: loading
      }],
      on: _objectSpread({}, on)
    }, (items || []).map(function (option) {
      return h('el-radio', {
        style: {
          lineHeight: '32px'
        },
        attrs: {},
        props: {
          key: option.value,
          disabled: option.disabled,
          label: keys ? option[keys['value']] : option['value']
        }
      }, [keys ? option[keys['label']] : option['label']]);
    })), typeof render.after === 'function' ? render.after.call(vm, h) : []];
  },
  //  下拉列表组件(特殊)
  'el-select': function elSelect(h, value, vm, _ref5) {
    var slot = _ref5.slot,
        _ref5$loading = _ref5.loading,
        loading = _ref5$loading === void 0 ? false : _ref5$loading,
        _ref5$label = _ref5.label,
        label = _ref5$label === void 0 ? '' : _ref5$label,
        _ref5$items = _ref5.items,
        items = _ref5$items === void 0 ? [] : _ref5$items,
        _ref5$on = _ref5.on,
        on = _ref5$on === void 0 ? {} : _ref5$on,
        _ref5$width = _ref5.width,
        width = _ref5$width === void 0 ? '' : _ref5$width,
        _ref5$attrs = _ref5.attrs,
        attrs = _ref5$attrs === void 0 ? {} : _ref5$attrs,
        _ref5$props = _ref5.props,
        props = _ref5$props === void 0 ? {} : _ref5$props,
        _ref5$style = _ref5.style,
        style = _ref5$style === void 0 ? {} : _ref5$style,
        _ref5$keys = _ref5.keys,
        keys = _ref5$keys === void 0 ? null : _ref5$keys,
        _ref5$render = _ref5.render,
        render = _ref5$render === void 0 ? {
      before: null,
      append: null,
      after: null
    } : _ref5$render,
        _ref5$ref = _ref5.ref,
        ref = _ref5$ref === void 0 ? null : _ref5$ref;
    if (!style.width) style.width = width || vm.componentWidth;
    return [typeof render.before === 'function' ? render.before.call(vm, h) : [], h('el-select', {
      style: _objectSpread({}, style),
      attrs: _objectSpread({
        placeholder: attrs.placeholder || '请选择' + label
      }, attrs),
      props: _objectSpread({
        value: value,
        placeholder: props.placeholder || '请选择' + label
      }, props),
      on: _objectSpread({}, on),
      directives: [{
        name: 'loading',
        value: loading
      }],
      slot: slot,
      ref: ref || name
    }, (items || []).map(function (option) {
      return h('el-option', {
        style: {
          minWidth: style.width
        },
        attrs: _objectSpread({}, option),
        props: {
          key: option.value,
          disabled: option.disabled,
          label: keys ? option[keys['label']] : option['label'],
          value: keys ? option[keys['value']] : option['value']
        }
      }, typeof render.append === 'function' ? render.append.call(vm, h, option) : []);
    }).concat(h('p', {
      style: {
        padding: '0px 0px',
        width: style.width,
        color: '#777777',
        fontSize: '14px',
        textAlign: 'center'
      },
      slot: 'empty'
    }, props.loading ? '加载中...' : '暂无数据'))), typeof render.after === 'function' ? render.after.call(vm, h) : []];
  },
  //  标签组件(特殊)
  'el-tag': function elTag(h, value, vm, _ref6) {
    var slot = _ref6.slot,
        _ref6$loading = _ref6.loading,
        loading = _ref6$loading === void 0 ? false : _ref6$loading,
        _ref6$label = _ref6.label,
        label = _ref6$label === void 0 ? '' : _ref6$label,
        _ref6$items = _ref6.items,
        items = _ref6$items === void 0 ? [] : _ref6$items,
        _ref6$on = _ref6.on,
        on = _ref6$on === void 0 ? {} : _ref6$on,
        _ref6$width = _ref6.width,
        width = _ref6$width === void 0 ? '' : _ref6$width,
        _ref6$attrs = _ref6.attrs,
        attrs = _ref6$attrs === void 0 ? {} : _ref6$attrs,
        _ref6$props = _ref6.props,
        props = _ref6$props === void 0 ? {} : _ref6$props,
        _ref6$style = _ref6.style,
        style = _ref6$style === void 0 ? {} : _ref6$style,
        _ref6$keys = _ref6.keys,
        keys = _ref6$keys === void 0 ? null : _ref6$keys,
        _ref6$render = _ref6.render,
        render = _ref6$render === void 0 ? {
      before: null,
      append: null,
      after: null
    } : _ref6$render,
        _ref6$ref = _ref6.ref,
        ref = _ref6$ref === void 0 ? null : _ref6$ref;
    return (items || []).map(function (option) {
      return h('el-tag', {
        style: _objectSpread({}, style),
        props: _objectSpread({
          key: keys ? option[keys['value']] : option['value']
        }, props),
        on: {
          close: on.close.bind(vm, items, option)
        }
      }, keys ? option[keys['label']] : option['label']);
    });
  },
  // 自定义组件 或 常规的饿了么组件 (特殊)
  'component': function component(h, value, vm, _ref7) {
    var slot = _ref7.slot,
        _ref7$loading = _ref7.loading,
        loading = _ref7$loading === void 0 ? false : _ref7$loading,
        _ref7$label = _ref7.label,
        label = _ref7$label === void 0 ? '' : _ref7$label,
        tag = _ref7.tag,
        _ref7$on = _ref7.on,
        on = _ref7$on === void 0 ? {} : _ref7$on,
        name = _ref7.name,
        _ref7$width = _ref7.width,
        width = _ref7$width === void 0 ? '' : _ref7$width,
        _ref7$attrs = _ref7.attrs,
        attrs = _ref7$attrs === void 0 ? {} : _ref7$attrs,
        _ref7$props = _ref7.props,
        props = _ref7$props === void 0 ? {} : _ref7$props,
        _ref7$style = _ref7.style,
        style = _ref7$style === void 0 ? {} : _ref7$style,
        _ref7$render = _ref7.render,
        render = _ref7$render === void 0 ? {
      before: null,
      append: null,
      after: null
    } : _ref7$render,
        _ref7$ref = _ref7.ref,
        ref = _ref7$ref === void 0 ? null : _ref7$ref;
    // 设置组件width
    if (!style.width && (tag === 'el-input' || tag === 'el-date-picker' || tag === 'el-autocomplete' || tag === 'el-cascader' || tag === 'el-time-picker')) style.width = width || vm.componentWidth; // 根据tag获取placeholder的前缀

    var placeholderDictByTag = {
      'el-input': '请输入',
      'el-autocomplete': '请输入',
      'el-date-picker': '请选择',
      'el-time-picker': '请选择',
      'el-cascader': '请选择'
    }; // 取消在范围选择器里取消两个日期面板之间的联动

    if (tag === 'el-date-picker' && props.type === 'daterange') Object.assign(props, {
      unlinkPanels: true
    }); // ［注意⚠️］默认给自定义组件开放了 v-model 的双向版定，每个组件内部只需要单独触发 this.$emit('input', 值) 就可以了

    return [typeof render.before === 'function' ? render.before.call(vm, h) : [], h(tag, {
      style: _objectSpread({}, style),
      attrs: _objectSpread(_objectSpread({}, !attrs.placeholder && _typeof(tag) !== 'object' ? {
        placeholder: placeholderDictByTag[tag] + label
      } : {}), attrs),
      props: _objectSpread(_objectSpread({
        value: value
      }, !props.placeholder && _typeof(tag) !== 'object' ? {
        placeholder: placeholderDictByTag[tag] + label
      } : {}), props),
      on: _objectSpread({
        // 用来监听自定义组件的值变化,是否开启
        validator: function validator(val) {
          vm.$refs[vm.formName].validateField([name]);
        }
      }, on),
      directives: [{
        name: 'loading',
        value: loading
      }],
      slot: slot,
      ref: ref || name
    }, typeof render.append === 'function' ? render.append.call(vm, h) : []), typeof render.after === 'function' ? render.after.call(vm, h) : []];
  },
  // 表单按钮
  'submit-buttons': function submitButtons(h, value, vm, item) {
    return [typeof item.submit === 'function' ? h('el-button', {
      attrs: {
        type: 'primary',
        size: vm.size
      },
      props: {
        loading: item.loading
      },
      on: {
        click: function click() {
          var isValid = vm.submitForm();
          if (typeof item.submit === 'function') item.submit.call(vm.$parent, isValid);
        }
      }
    }, item.submitText || '提交') : [], typeof item.reset === 'function' ? h('el-button', {
      attrs: {
        type: 'primary',
        size: vm.size
      },
      on: {
        click: function click() {
          vm.resetForm();
          if (typeof item.reset === 'function') item.reset.call(vm.$parent);
        }
      }
    }, item.resetText || '重置') : [], typeof item.back === 'function' ? h('el-button', {
      attrs: {
        type: '',
        size: vm.size
      },
      on: {
        click: function click() {
          if (typeof item.back === 'function') item.back.call(vm.$parent);
        }
      }
    }, item.backText || '返回') : []];
  }
};